import type {Vector2, Texture, Color} from 'three'
import {Mesh, ShaderMaterial, Vector3, Vector4, Group} from 'three'
import assets from './assets'

import shaders from './glsl/shaders'

import common from './common'
import {commonUniforms} from './utils/common-uniforms'

interface MaterialOptions {
  isCheck: boolean
}

export default class Shield {
  group: Group = new Group()
  progress: Vector4 = new Vector4(0, 0, 0, 0)
  lightPos: Vector3 = new Vector3(-0.5, 1.0, -2.0)
  shieldBackGroup: Group = new Group()
  uniforms: {[uniform: string]: {value: number | Vector2 | Vector4 | Vector3 | Color | Texture | null}}

  constructor() {
    this.uniforms = {
      ...commonUniforms,
      uMatcap: {
        value: null,
      },
      uRandom: {
        value: new Vector3(Math.random(), Math.random(), Math.random()),
      },
      uLightPos: {
        value: this.lightPos,
      },
      uResolution: {
        value: common.fbo_screenSize,
      },
      uProgress: {
        value: this.progress,
      },
    }
  }

  init(): void {
    this.createMesh()
  }

  createMesh(): void {
    if (this.uniforms.uMatcap && assets.images.matcap4 && assets.images.matcap4.texture) {
      this.uniforms.uMatcap.value = assets.images.matcap4.texture
    }

    if (assets.gltfs.shield?.scene) {
      assets.gltfs.shield.scene.traverse(object => {
        if (object.type === 'Mesh') {
          const geometry = (object as Mesh).geometry

          const material = this.createMaterial({isCheck: object.name === 'check'})
          const mesh = new Mesh(geometry, material)
          this.group.add(mesh)

          const material_back = this.createMaterial_back()
          const mesh_back = new Mesh(geometry, material_back)
          mesh_back.scale.set(1.03, 1.03, 1.03)
          this.shieldBackGroup.add(mesh_back)
        }
      })
    }
  }

  createMaterial({isCheck}: MaterialOptions): ShaderMaterial {
    const uniforms = {
      ...this.uniforms,
    }

    const material = new ShaderMaterial({
      vertexShader: shaders.shieldVert,
      fragmentShader: shaders.utils + shaders.shieldFrag,
      uniforms,
      transparent: true,
      defines: {
        CHECK: isCheck ? 1 : 0,
      },
    })

    return material
  }

  createMaterial_back(): ShaderMaterial {
    return new ShaderMaterial({
      vertexShader: shaders.shield_backVert,
      fragmentShader: shaders.utils + shaders.shield_backFrag,
      uniforms: this.uniforms,
      transparent: true,
    })
  }

  update(): void {}
}
